'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _gallery = require('./gallery.component');

var _gallery2 = _interopRequireDefault(_gallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var galleryModule = _angular2.default.module('gallery', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.detail.gallery', {
    url: '/gallery',
    component: 'gallery',
    params: {
      item: null
    }
  });
}).component('gallery', _gallery2.default).name;

exports.default = galleryModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/gallery/gallery.js